module.exports = __webpack_public_path__ + "img/favicon.f1100c2.png";